import React from 'react';
import { cx } from './cx';

export interface KeyValueItem {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Stronger value text (totals). */
  emphasis?: boolean;
}

export interface KeyValueListProps {
  items: KeyValueItem[];
  className?: string;
}

/** Label/value rows on the inset surface (summaries, limits, details). */
export default function KeyValueList({ items, className }: KeyValueListProps) {
  return (
    <dl className={cx('m-0 flex flex-col overflow-hidden rounded-control border border-edge-subtle bg-inset', className)}>
      {items.map((it, i) => (
        <div key={i} className="flex items-baseline justify-between gap-3 border-t border-edge-subtle px-3 py-2.5 first:border-t-0">
          <dt className="min-w-0 font-ui text-small text-secondary">{it.label}</dt>
          <dd className={cx('m-0 text-right font-ui text-small text-primary', it.emphasis && 'font-semibold')}>{it.value}</dd>
        </div>
      ))}
    </dl>
  );
}
